export function assignLocation(url: string) {
  window.location.assign(url);
}

export function replaceLocation(url: string) {
  window.location.replace(url);
}

export function getWindowHref() {
  return window.location.href;
}

export function getWindowOrigin() {
  return window.location.origin;
}

export function getCurrentPath() {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}
